/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_drop = /** @type {(inputs: {}) => string} */ () => {
	return `Drop`
};

const da_attributes_drop = /** @type {(inputs: {}) => string} */ () => {
	return `Drop`
};

const de_attributes_drop = /** @type {(inputs: {}) => string} */ () => {
	return `Drop`
};

const en_attributes_drop = /** @type {(inputs: {}) => string} */ () => {
	return `Drop`
};

const es_attributes_drop = /** @type {(inputs: {}) => string} */ () => {
	return `Drop`
};

const fr_attributes_drop = /** @type {(inputs: {}) => string} */ () => {
	return `Drop`
};

const hu_attributes_drop = /** @type {(inputs: {}) => string} */ () => {
	return `Drop`
};

const it_attributes_drop = /** @type {(inputs: {}) => string} */ () => {
	return `Drop`
};

const nl_attributes_drop = /** @type {(inputs: {}) => string} */ () => {
	return `Drop`
};

const pl_attributes_drop = /** @type {(inputs: {}) => string} */ () => {
	return `Drop`
};

const pt_attributes_drop = /** @type {(inputs: {}) => string} */ () => {
	return `Drop`
};

const sv_attributes_drop = /** @type {(inputs: {}) => string} */ () => {
	return `Drop`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_drop = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_drop(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_drop", locale)
	if (locale === "cs") return cs_attributes_drop(inputs)
	if (locale === "da") return da_attributes_drop(inputs)
	if (locale === "de") return de_attributes_drop(inputs)
	if (locale === "en") return en_attributes_drop(inputs)
	if (locale === "es") return es_attributes_drop(inputs)
	if (locale === "fr") return fr_attributes_drop(inputs)
	if (locale === "hu") return hu_attributes_drop(inputs)
	if (locale === "it") return it_attributes_drop(inputs)
	if (locale === "nl") return nl_attributes_drop(inputs)
	if (locale === "pl") return pl_attributes_drop(inputs)
	if (locale === "pt") return pt_attributes_drop(inputs)
	return sv_attributes_drop(inputs)
};
export { attributes_drop as "attributes.drop" }